import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { accountService } from "../services/accountService";
import Warning from "./Warning";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [invalid, setInvalid] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const [password, setPassword] = useState<string>();
  const [confirmPassword, setConfirmPassword] = useState<string>();

  const token = location.pathname.substring(
    location.pathname.lastIndexOf("/") + 1
  );

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setInvalid(false);
    if (confirmPassword && password) {
      try {
        await accountService.resetPassword({
          token,
          password,
          confirmPassword,
        });
        setSuccess(true);
        setIsSubmitting(false);
      } catch (error) {
        setIsSubmitting(false);
        setInvalid(true);
      }
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      className="shadow-box"
      style={{ width: 400, maxWidth: "100%", margin: "auto" }}
    >
      {success ? (
        <>
          <p>Hasło zostało zresetowane</p>
          <Button onClick={() => navigate("/login")}>Zaloguj</Button>
        </>
      ) : (
        <>
          <FormGroup>
            <Input
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nowe hasło"
              type="password"
              name="password"
              id="password"
            />
          </FormGroup>
          <FormGroup>
            <Input
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              placeholder="Powtórz hasło"
              name="repeat-password"
              id="repeatPassword"
            />
          </FormGroup>
          {invalid && (
            <Warning>Nazwa użytkownika lub hasło są niepoprawne</Warning>
          )}
          {isSubmitting ? (
            <div className="spinner" />
          ) : (
            <Button disabled={isSubmitting}>Zapisz</Button>
          )}
        </>
      )}
    </Form>
  );
};

export default ResetPassword;
